import React, { useContext, useEffect, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Box,
  Button,
  Fab,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import SelectTime from "./SelectTime";
import { Add, ArrowBack, ArrowForward, Close } from "@mui/icons-material";
import AddTimeEntriesDialog from "./AddTimeEntriesDialog";
import { SnackAlertContext } from "../../../context/SnackAlertContext";
import { AuthContext } from "../../../context/AuthContext";
import { toThreeDecimals } from "../../../components/NewDetail/calculations/utils";
import NoWorkSwitch from "./NoWorkSwitch";
import BreakMinutes from "./BreakMinutes";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

// isoDate is "YYYY-MM-DD"
// the isoDateParam will always be treated as a Phoenix Date
const TimeEntries = ({ isoDateParam }) => {
  // If there is no timezone information passed in, it assumes LOCAL TIME and reads the date string as local time
  // so if we pass in "2025-06-27 00:00:00" it is 2025-06-27 00:00:00 ARIZONA TIME or 2025-06-27 00:00:00 -07:00
  // so this is 7:00 am UTC
  console.log(
    // THIS IS READING THE DATE PARAM LOCAL TIME AND CONVERTS TO UTC WHEN PRINTING
    // LOCAL TIME IS ARIZONA WHICH HAS A -07:00 OFFSET (7 HOURS BEHIND UTC)
    // TO CONVERT TO UTC WE SUBTRACT THE OFFSET HOURS FROM THE LOCAL (12AM - 8 = 4PM YESTERDAY)
    // 2025-06-27 00:00:00 ARIZONA - (-7) = 2025-06-27 07:00:00.000 UTC
    dayjs("2025-06-27 00:00:00").valueOf(), // 1751007600000
    dayjs("2025-06-27 00:00:00").toISOString() // '2025-06-27T07:00:00.000Z' - 7 am UTC
  );
  console.log(
    // THIS TIME WE ACTUALLY PASSED IN A TIMEZONE OFFSET SO IT WILL ACTUALLY READ THE DATE STRING IN THAT TIMEZONE
    // 2025-06-27 00:00:00 +00:00 is zero offset so this is actually 2025-06-27 00:00:00 UTC
    dayjs("2025-06-27 00:00:00 +00:00", "YYYY-MM-DD HH:mm:ss Z").valueOf(), // 1751007600000
    dayjs("2025-06-27 00:00:00 +00:00", "YYYY-MM-DD HH:mm:ss Z").toISOString() // '2025-06-27T00:00:00.000Z'
  );

  console.log(
    // THIS TIME WE ACTUALLY PASSED IN A TIMEZONE OFFSET SO IT WILL ACTUALLY READ THE DATE STRING IN THAT TIMEZONE
    // 2025-06-27 00:00:00 - (-7) = 2025-06-27 07:00:00 LOCAL (ARIZONA)
    dayjs("2025-06-27 00:00:00 -07:00", "YYYY-MM-DD HH:mm:ss Z").valueOf(), // 1751007600000
    dayjs("2025-06-27 00:00:00 -07:00", "YYYY-MM-DD HH:mm:ss Z").toISOString() // '2025-06-27T07:00:00.000Z'
  );

  console.log(
    // THIS IS READING THE DATE PARAM IN UTC AND CONVERTS TO LOCAL (Arizona is -7 OFFSET)
    // 2025-06-27 00:00:00 UTC - (+8) = 2025-06-26 4pm or 2025-06-26 16:00Z
    dayjs("2025-06-27 00:00:00 +08:00", "YYYY-MM-DD HH:mm:ss Z").valueOf(), // 1751007600000
    dayjs("2025-06-27 00:00:00 +08:00", "YYYY-MM-DD HH:mm:ss Z").toISOString() // '2025-06-27T07:00:00.000Z'
  );

  // The UTC offset for manila is +08:00 (8 horus ahead of UTC)
  // Another option is to use the timezone with 2 params: dayjs.tz(date, timezone)
  // This reads the datetime and adds the UTC offset for the selected timezone
  console.log(
    // THIS IS READING THE DATE PARAM AS IF IT WAS IN THE TIMEZONE IN  THE SECOND PARAM
    // So tis is reading midnight in Manila or 2025-06-27 00:00:00 MANILA (+8)
    // Manila is 8 hours ahead of UTC, so to convert it to UTC we subtract 8 hours
    // 2025-06-27 00:00 MANILA - (+8) = 2025-06-26 4pm or 2025-06-26 16:00
    dayjs.tz("2025-06-27 00:00:00", "Asia/Manila").valueOf(), // 1750953600000
    dayjs.tz("2025-06-27 00:00:00", "Asia/Manila").toISOString() // '2025-06-26T16:00:00.000Z'
  );

  // TO KEEP IT SIMPLE
  // 1.) only use dayjs.tz("dateString", DEFAULT_TIMEZONE) if the datestring doesn't have any offset or timezone info already
  //      - basically when using an isoDate string which will only have the date
  // 2.) dayjs(dateObject or dateString from db).tz(DEFAULT_TIMEZONE) does not change the value but it does change the output for startOf/endOf
  const getPhoenixDayJs = (isoDate) => {
    return isoDate
      ? dayjs.tz(isoDate, DEFAULT_TIMEZONE).startOf("day") // Treat "YYYY-MM-DD" passed in as a Phoenix Arizona Date
      : dayjs().tz(DEFAULT_TIMEZONE).startOf("day"); // Convert current time to arizona time
  };

  // So if you were reading this in a different country which is 1 day ahead, it will load that "YYYY-MM-DD"
  // as if it was "YYYY-MM-DD" in Arizona
  const navigate = useNavigate();
  const { ezorder, authToken } = useContext(AuthContext);
  const { openSnackMessage } = useContext(SnackAlertContext);
  const [loading, setLoading] = useState(false);
  const [timeEntries, setTimeEntries] = useState([]);
  const [addTimeEntriesDialogOpen, setAddTimeEntriesDialogOpen] =
    useState(false);
  const [editing, setEditing] = useState(false);

  const setDate = (dateUpdate) => {
    let query = [];
    if (dateUpdate) {
      query.push(`date=${dateUpdate}`);
    }
    if (query.length > 0) {
      navigate(`/time-entries?${query.join("&")}`); // search=hello&status=DRAFT
    } else {
      navigate(`/time-entries`);
    }
  };

  // TODO: Read this
  // https://day.js.org/docs/en/plugin/timezone
  const getTimeEntriesByPhoenixIsoDate = async () => {
    try {
      setLoading(true);
      let phoenixIsoDate = getPhoenixDayJs(isoDateParam)
        .tz(DEFAULT_TIMEZONE)
        .format("YYYY-MM-DD");

      let response = await ezorder.get(`/time-entries/${phoenixIsoDate}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status == 200 || response.status === 201) {
        setTimeEntries(response.data.timeEntries);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const saveTimeEntries = async () => {
    try {
      setLoading(true);

      let timeEntriesToSubmit = [];
      let timeEntriesCopy = [...timeEntries];
      for (let timeEntry of timeEntriesCopy) {
        // Erase Time Entry Data Depending on if No Work or Not
        if (timeEntry.noWork) {
          timeEntry.start = null;
          timeEntry.stop = null;
          timeEntry.workMinutes = 0;
          timeEntry.lunchDurationMinutes = 0;
          timeEntry.breakMinutes = 0;
          timeEntry.breakReason = null;
        } else {
          timeEntry.noWorkReason = null;
        }

        // Exclude time Entries with Weekly Summaries Already Signed
        if (
          timeEntry.weeklyUserTimeSummary &&
          timeEntry.weeklyUserTimeSummary.adminApprovedOn
        ) {
          // week is already approved. Do not save time entry
        } else {
          timeEntriesToSubmit.push(timeEntry);
        }
      }

      let response = await ezorder.post(
        `/time-entries`,
        { timeEntries: timeEntriesToSubmit },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status == 200 || response.status === 201) {
        openSnackMessage("success", "Saved");
        getTimeEntriesByPhoenixIsoDate();
        setEditing(false);
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const deleteTimeEntry = async (timeEntryId) => {
    try {
      setLoading(true);

      let response = await ezorder.delete(`/time-entry/${timeEntryId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status == 200 || response.status === 201) {
        openSnackMessage("success", "Deleted");
        getTimeEntriesByPhoenixIsoDate();
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTimeEntriesByPhoenixIsoDate();
  }, [isoDateParam]);

  return (
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            disabled={editing}
            color="primary"
            onClick={() => {
              let current = getPhoenixDayJs(isoDateParam);
              let prev = current.subtract(1, "day");
              setDate(prev.tz(DEFAULT_TIMEZONE).format("YYYY-MM-DD"));
            }}
          >
            <ArrowBack />
          </IconButton>
          <DesktopDatePicker
            disabled={editing}
            inputFormat="ddd MM/DD/YY" // display format
            label="Date (Phoenix Arizona)"
            // BY DEFAULT, DAYJS.format() will format in local time and not UTC
            // So the YYYY-MM-DD we're parsing out will be accurate
            value={getPhoenixDayJs(isoDateParam)}
            onChange={(newValue) => {
              setDate(newValue.tz(DEFAULT_TIMEZONE).format("YYYY-MM-DD"));
            }}
            renderInput={(params) => (
              <TextField size="small" sx={{ width: "200px" }} {...params} />
            )}
          />
          <IconButton
            disabled={editing}
            color="primary"
            onClick={() => {
              let current = getPhoenixDayJs(isoDateParam);
              let next = current.add(1, "day");
              setDate(next.tz(DEFAULT_TIMEZONE).format("YYYY-MM-DD"));
            }}
          >
            <ArrowForward />
          </IconButton>
        </Box>
        <TableContainer component={Box}>
          <Table sx={{}}>
            <TableHead>
              <TableRow>
                {!editing && <TableCell align="left"></TableCell>}
                <TableCell align="left">Employee</TableCell>
                <TableCell align="left">Start</TableCell>
                <TableCell align="left">Stop</TableCell>
                <TableCell align="left">Lunch Mins</TableCell>
                <TableCell align="left">Break Mins</TableCell>
                <TableCell align="left">Hours</TableCell>
                <TableCell align="left">Week Total</TableCell>
                <TableCell align="left">No Work</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {timeEntries &&
                timeEntries.map((timeEntry, index) => {
                  return (
                    <TableRow key={timeEntry.id}>
                      {!editing && (
                        <TableCell align="left" sx={{ width: "40px" }}>
                          <IconButton
                            disabled={
                              timeEntry.weeklyUserTimeSummary.adminApprovedOn
                            }
                            onClick={() => {
                              deleteTimeEntry(timeEntry.id);
                            }}
                          >
                            <Close />
                          </IconButton>
                        </TableCell>
                      )}

                      <TableCell align="left">
                        <Box
                          sx={{
                            width: "130px",
                            textTransform: "uppercase",
                            fontWeight: "bold",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "1",
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {timeEntry.user.fullName}
                        </Box>
                      </TableCell>
                      <TableCell align="left">
                        <Box sx={{ width: "130px" }}>
                          {!timeEntry.noWork && (
                            <SelectTime
                              disabled={
                                !editing ||
                                timeEntry.weeklyUserTimeSummary.adminApprovedOn
                              }
                              size="small"
                              timezone={DEFAULT_TIMEZONE}
                              value={dayjs(timeEntry.start).tz(
                                DEFAULT_TIMEZONE
                              )}
                              onUpdate={(value) => {
                                let timeEntriesCopy = [...timeEntries];
                                timeEntriesCopy[index].start = value;

                                // Hours = (stop - start) - (lunch mins + break mins)
                                let timeStart = dayjs(
                                  timeEntriesCopy[index].start
                                ).tz(DEFAULT_TIMEZONE);
                                let timeStop = dayjs(
                                  timeEntriesCopy[index].stop
                                ).tz(DEFAULT_TIMEZONE);
                                let totalMinutes = timeStop.diff(
                                  timeStart,
                                  "minutes"
                                );
                                let workMinutes =
                                  totalMinutes -
                                  Number(
                                    timeEntriesCopy[index]
                                      .lunchDurationMinutes ?? 0
                                  ) -
                                  Number(
                                    timeEntriesCopy[index].breakMinutes ?? 0
                                  );
                                timeEntriesCopy[index].workMinutes =
                                  workMinutes;

                                setTimeEntries(timeEntriesCopy);
                              }}
                              maxTime={dayjs(timeEntry.stop).tz(
                                DEFAULT_TIMEZONE
                              )}
                            />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell align="left">
                        <Box sx={{ width: "130px" }}>
                          {!timeEntry.noWork && (
                            <SelectTime
                              disabled={
                                !editing ||
                                timeEntry.weeklyUserTimeSummary.adminApprovedOn
                              }
                              size="small"
                              timezone={DEFAULT_TIMEZONE}
                              value={dayjs(timeEntry.stop).tz(DEFAULT_TIMEZONE)}
                              onUpdate={(value) => {
                                let timeEntriesCopy = [...timeEntries];
                                timeEntriesCopy[index].stop = value;

                                // Hours = (stop - start) - (lunch mins + break mins)
                                let timeStart = dayjs(
                                  timeEntriesCopy[index].start
                                ).tz(DEFAULT_TIMEZONE);
                                let timeStop = dayjs(
                                  timeEntriesCopy[index].stop
                                ).tz(DEFAULT_TIMEZONE);
                                let totalMinutes = timeStop.diff(
                                  timeStart,
                                  "minutes"
                                );
                                let workMinutes =
                                  totalMinutes -
                                  Number(
                                    timeEntriesCopy[index]
                                      .lunchDurationMinutes ?? 0
                                  ) -
                                  Number(
                                    timeEntriesCopy[index].breakMinutes ?? 0
                                  );
                                timeEntriesCopy[index].workMinutes =
                                  workMinutes;

                                setTimeEntries(timeEntriesCopy);
                              }}
                              minTime={dayjs(timeEntry.start).tz(
                                DEFAULT_TIMEZONE
                              )}
                            />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell align="left">
                        {!timeEntry.noWork && (
                          <TextField
                            disabled={
                              !editing ||
                              timeEntry.weeklyUserTimeSummary.adminApprovedOn
                            }
                            size="small"
                            sx={{ width: "80px" }}
                            type="number"
                            value={timeEntry.lunchDurationMinutes}
                            onChange={(e) => {
                              let timeEntriesCopy = [...timeEntries];
                              timeEntriesCopy[index].lunchDurationMinutes =
                                e.target.value;

                              // Hours = (stop - start) - (lunch mins + break mins)
                              let timeStart = dayjs(
                                timeEntriesCopy[index].start
                              ).tz(DEFAULT_TIMEZONE);
                              let timeStop = dayjs(
                                timeEntriesCopy[index].stop
                              ).tz(DEFAULT_TIMEZONE);
                              let totalMinutes = timeStop.diff(
                                timeStart,
                                "minutes"
                              );
                              let workMinutes =
                                totalMinutes -
                                Number(
                                  timeEntriesCopy[index].lunchDurationMinutes ??
                                    0
                                ) -
                                Number(
                                  timeEntriesCopy[index].breakMinutes ?? 0
                                );
                              timeEntriesCopy[index].workMinutes = workMinutes;

                              setTimeEntries(timeEntriesCopy);
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell align="left">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          {!timeEntry.noWork && (
                            <BreakMinutes
                              disabled={
                                !editing ||
                                timeEntry.weeklyUserTimeSummary.adminApprovedOn
                              }
                              size="small"
                              sx={{ width: "80px" }}
                              value={timeEntry.breakMinutes}
                              onChange={(e) => {
                                let timeEntriesCopy = [...timeEntries];
                                timeEntriesCopy[index].breakMinutes =
                                  e.target.value;

                                // Hours = (stop - start) - (lunch mins + break mins)
                                let timeStart = dayjs(
                                  timeEntriesCopy[index].start
                                ).tz(DEFAULT_TIMEZONE);
                                let timeStop = dayjs(
                                  timeEntriesCopy[index].stop
                                ).tz(DEFAULT_TIMEZONE);
                                let totalMinutes = timeStop.diff(
                                  timeStart,
                                  "minutes"
                                );
                                let workMinutes =
                                  totalMinutes -
                                  Number(
                                    timeEntriesCopy[index]
                                      .lunchDurationMinutes ?? 0
                                  ) -
                                  Number(
                                    timeEntriesCopy[index].breakMinutes ?? 0
                                  );
                                timeEntriesCopy[index].workMinutes =
                                  workMinutes;

                                setTimeEntries(timeEntriesCopy);
                              }}
                              reason={timeEntry.breakReason}
                              onReasonChange={(newReason) => {
                                let timeEntriesCopy = [...timeEntries];
                                timeEntriesCopy[index].breakReason = newReason;
                                setTimeEntries(timeEntriesCopy);
                              }}
                            />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell align="left">
                        {!timeEntry.noWork && (
                          <>
                            {toThreeDecimals(
                              Number(timeEntry.workMinutes ?? 0) / 60
                            )}
                          </>
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {toThreeDecimals(
                          Number(
                            timeEntry.weeklyUserTimeSummary.totalWorkMinutes ??
                              0
                          ) / 60
                        )}
                      </TableCell>
                      <TableCell align="left">
                        <NoWorkSwitch
                          disabled={
                            !editing ||
                            timeEntry.weeklyUserTimeSummary.adminApprovedOn
                          }
                          checked={timeEntry.noWork}
                          onChange={(e) => {
                            let timeEntriesCopy = [...timeEntries];
                            if (e.target.checked) {
                              // No Work
                              timeEntriesCopy[index].noWork = e.target.checked;

                              setTimeEntries(timeEntriesCopy);
                            } else {
                              // Yes Work
                              timeEntriesCopy[index].noWork = e.target.checked;

                              // If start, stop, lunch, etc. are actually null (saved no-work timecard toggled to work)
                              // Then fill in null data using user defaults
                              if (timeEntriesCopy[index].start == null) {
                                let start = dayjs(
                                  `${getPhoenixDayJs(isoDateParam)
                                    .tz(DEFAULT_TIMEZONE)
                                    .format("YYYY-MM-DD")} ${
                                    timeEntriesCopy[index].user.workStartTime
                                  }`,
                                  "YYYY-MM-DD HH:mm Z"
                                ).tz(DEFAULT_TIMEZONE);
                                timeEntriesCopy[index].start = start;
                                let stop = start.add(
                                  timeEntriesCopy[index].user
                                    .workDurationMinutes,
                                  "minutes"
                                );
                                timeEntriesCopy[index].stop = stop;
                                timeEntriesCopy[index].breakMinutes = 0;
                                timeEntriesCopy[index].breakReason = null;
                                timeEntriesCopy[index].lunchDurationMinutes =
                                  timeEntriesCopy[
                                    index
                                  ].user.lunchDurationMinutes;

                                // Hours = (stop - start) - (lunch mins + break mins)
                                let timeStart = dayjs(
                                  timeEntriesCopy[index].start
                                ).tz(DEFAULT_TIMEZONE);
                                let timeStop = dayjs(
                                  timeEntriesCopy[index].stop
                                ).tz(DEFAULT_TIMEZONE);
                                let totalMinutes = timeStop.diff(
                                  timeStart,
                                  "minutes"
                                );
                                let workMinutes =
                                  totalMinutes -
                                  Number(
                                    timeEntriesCopy[index]
                                      .lunchDurationMinutes ?? 0
                                  ) -
                                  Number(
                                    timeEntriesCopy[index].breakMinutes ?? 0
                                  );
                                timeEntriesCopy[index].workMinutes =
                                  workMinutes;
                              }

                              setTimeEntries(timeEntriesCopy);
                            }
                          }}
                          reason={timeEntry.noWorkReason}
                          onReasonChange={(newReason) => {
                            let timeEntriesCopy = [...timeEntries];
                            timeEntriesCopy[index].noWorkReason = newReason;
                            setTimeEntries(timeEntriesCopy);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}

              {!editing && (
                <TableRow>
                  <TableCell align="center" colspan={20}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setAddTimeEntriesDialogOpen(true);
                      }}
                    >
                      <Add sx={{ marginRight: "8px" }} />
                      Add Time Cards
                    </Button>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </LocalizationProvider>
      <AddTimeEntriesDialog
        isoDate={getPhoenixDayJs(isoDateParam)
          .tz(DEFAULT_TIMEZONE)
          .format("YYYY-MM-DD")}
        open={addTimeEntriesDialogOpen}
        handleClose={() => {
          setAddTimeEntriesDialogOpen(false);
        }}
        onSuccess={() => {
          // let timeEntriesCopy = [...timeEntries, ...newTimeEntries];
          // setTimeEntries(timeEntriesCopy);
          // setAddTimeEntriesDialogOpen(false);
          getTimeEntriesByPhoenixIsoDate();
        }}
      />
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "50px",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        {editing ? (
          <>
            <Fab
              onClick={() => {
                saveTimeEntries();
              }}
              variant="extended"
              color="success"
            >
              Save Changes
            </Fab>
            <Fab
              onClick={() => {
                setEditing(false);
              }}
              variant="extended"
              // color="success"
            >
              Cancel
            </Fab>
          </>
        ) : (
          <>
            <Fab
              onClick={() => {
                setEditing(true);
              }}
              variant="extended"
              color="success"
            >
              Edit Entries
            </Fab>
            <Fab
              onClick={() => {
                let startOfWeekIsoDateFormat = getPhoenixDayJs(isoDateParam)
                  .tz(DEFAULT_TIMEZONE)
                  .startOf("isoWeek")
                  .format("YYYY-MM-DD");
                navigate(
                  `/weekly-time-summaries?date=${startOfWeekIsoDateFormat}`
                );
              }}
              variant="extended"
              color="success"
            >
              Weekly Summary
            </Fab>
          </>
        )}
      </div>
    </Box>
  );
};

export default TimeEntries;
